import * as api from '../../services/questionnaire'

export const FETCH_QUESTIONNAIRES = 'FETCH_QUESTIONNAIRES';
export const FETCH_ADMIN_QUESTIONNAIRES = 'FETCH_ADMIN_QUESTIONNAIRES';
export const FETCH_SURVEYANSWERS = 'FETCH_SURVEYANSWERS';
export const FETCH_VOTES = 'FETCH_VOTES';
export const FETCH_ADMIN_VOTES = 'FETCH_ADMIN_VOTES';



export const fetchQuestionnaires = (params, pagination, sort, extra) => {
    return {
        type: FETCH_QUESTIONNAIRES,
        payload: {
            promise: api.findSurveys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchAdminQuestionnaires = (params, pagination, sort, extra) => {
    return {
        type: FETCH_ADMIN_QUESTIONNAIRES,
        payload: {
            promise: api.findAdminSurveys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchSurveyAnswers= (params, pagination, sort, extra) => {
    return {
        type: FETCH_SURVEYANSWERS,
        payload: {
            promise: api.findSurveyAnswers(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchVotes= (params, pagination, sort, extra) => {
    return {
        type: FETCH_VOTES,
        payload: {
            promise: api.findVotes(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchAdminVotes= (params, pagination, sort, extra) => {
    return {
        type: FETCH_ADMIN_VOTES,
        payload: {
            promise: api.findAdminVotes(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}





// WEBPACK FOOTER //
// ./src/redux/actions/questionnaires.js